if (customElements.get('siphox-reports-list') === undefined) {
  class SiphoxReportsList extends HTMLElement {
    constructor() {
      super();
    }

    async connectedCallback() {
      this.email = this.getAttribute('email');
      this.customerId = this.getAttribute('customer-id');
      this.reports = await this.getReportsList();
      this.oldReport = await this.getOldReport();
      this.emptyState = this.querySelector('[data-state="hidden"]');
      this.showState = this.querySelector('[data-state="show"]');
      this.loader = document.getElementById('loader_main');

      if (this.reports.length > 0 || this.oldReport) {
        this.fillReportsList();
        this.fillOldReport();

        this.showState.classList.remove('hidden');
        this.loader.classList.add('hidden');
      } else {
        this.emptyState.classList.remove('hidden');
        this.loader.classList.add('hidden');
      }
    }

    async getReportsList() {
      try {
        let reports = [];
        const res = await fetch('/apps/mira-labtest/api/get-reports', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: this.email,
          }),
        });
        const response = await res.json();
        if (response.data.reports.length > 0) {
          reports = response.data.reports;
        }

        return reports;
      } catch (error) {
        console.error('Error fetching reports:', error);
        return [];
      }
    }

    async getOldReport() {
      try {
        let report = null;

        const res = await fetch('https://www.miracare.com/wp-json/api/lab-test-api/get_report_data', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            user_id: this.customerId,
          }),
        });
        const response = await res.json();
        if (response.report_data) {
          report = response.report_data;
        }

        return report;
      } catch (error) {
        console.error('Error fetching reports:', error);
        return [];
      }
    }

    fillOldReport() {
      const reportsContainer = this.querySelector('[data-reports-list]');

      if (!this.oldReport) {
        return;
      }

      const reportsHTML = this.generateOldReportCard(this.oldReport);

      reportsContainer.insertAdjacentHTML('afterbegin', reportsHTML);
    }

    generateOldReportCard(report) {
      console.log('old report', report);
      let overviewPageUrl = `/pages/lab-test?date=${report.created_date}`;
      let testName = 'Panorama Lab test';

      return `
        <div class="flex flex-col gap-2.4 rounded-1.2 bg-[linear-gradient(110deg,#F2F1ED_0%,#FAF6E7_98.6%)] px-1.2 pb-2.4 pt-1.2">
            <span class="w-max rounded-md bg-white px-0.8 py-0.4 text-md text-dark-cyan">Report uploaded</span>
            <h4 class="text-2.4 leading-none text-dark-cyan">${testName}</h4>

            <div>
                <p class="border-b border-solid border-dark-green-80 py-1.2">Date of report: <span>${this.formatDate(report.created_date)}</span></p>
            </div>

            <a class="button-default button-primary button-medium w-max" href="${overviewPageUrl}"
                >View Report</a
            >
            </div>
        </div>
      `;
    }

    fillReportsList() {
      const reportsContainer = this.querySelector('[data-reports-list]');

      if (!Array.isArray(this.reports) || this.reports.length === 0) {
        return;
      }

      let reportsHTML = '';
      this.reports.forEach((report) => {
        reportsHTML += this.generateReportCard(report);
      });

      reportsContainer.insertAdjacentHTML('beforeend', reportsHTML);
    }

    generateReportCard(report) {
      let overviewPageUrl = `/pages/lab-test-overview?reportId=${report.id}`;
      let testName = 'Panorama Lab test';

      if (report.kit_type === 'perimenopause') {
        overviewPageUrl = `/pages/perimenopause-overview?reportId=${report.id}`;
        testName = 'Panorama Lab test for Perimenopause';
      }

      return `
        <div class="flex flex-col gap-2.4 rounded-1.2 bg-[linear-gradient(110deg,#F2F1ED_0%,#FAF6E7_98.6%)] px-1.2 pb-2.4 pt-1.2">
            <span class="w-max rounded-md bg-white px-0.8 py-0.4 text-md text-dark-cyan">Report uploaded</span>
            <h4 class="text-2.4 leading-none text-dark-cyan">${testName}</h4>

            <div>
                <p class="border-b border-solid border-dark-green-80 py-1.2">
                Date of collection: <span>${this.formatDate(report.collectedDate)}</span>
                </p>
                <p class="border-b border-solid border-dark-green-80 py-1.2">Date of report: <span>${this.formatDate(report.resultedDate)}</span></p>
            </div>

            <a class="button-default button-primary button-medium w-max" href="${overviewPageUrl}"
                >View Report</a
            >
            </div>
        </div>
      `;
    }

    formatDate(dateString) {
      const date = new Date(dateString);
      const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      };
      const formatted = date.toLocaleString('en-US', options);
      return formatted.replace(',', '');
    }
  }

  customElements.define('siphox-reports-list', SiphoxReportsList);
}
